import { isValidDate } from '@cian/utils';

import { getMonthNames } from './getMonthNames';
import { getMoscowDateParts, mapRelativeDayInMoscow } from './moscowDate';

type TDayNames = 'сегодня' | 'вчера' | 'позавчера';

export type TFormatDateOptions = {
  dayNames?: TDayNames[];
  skipCurrentYear?: boolean;
  /** Опорный «сейчас» для SSR и гидрации (например new Date(serverTimestamp)). */
  referenceNow?: Date;
};

/**
 * Форматирует дату в календаре Москвы (сервер и браузер дают одинаковую строку).
 *
 * Возможные результаты:
 * - пустое значение, если дата некорректна: ""
 * - строковое представление, если есть в options.dayNames: "сегодня" | "вчера" | "позавчера"
 * - без текущего года, если есть skipCurrentYear и год совпадает с referenceNow в Москве
 * - полное представление: "21 января 2023"
 */
export function formatDate(date: Date, options?: TFormatDateOptions) {
  if (!isValidDate(date)) {
    return '';
  }

  const now = options?.referenceNow ?? new Date();
  const day = mapRelativeDayInMoscow(date, now);

  if (day && (options?.dayNames || []).includes(day)) {
    return day;
  }

  const { day: d, monthIndex, year } = getMoscowDateParts(date);
  const { year: nowYear } = getMoscowDateParts(now);

  if (options?.skipCurrentYear && nowYear === year) {
    return `${d} ${getMonthNames()[monthIndex]}`;
  }

  return `${d} ${getMonthNames()[monthIndex]} ${year}`;
}
